import React from "react";
import { TICKER } from "@/lib/site";

export default function Ticker() {
  const items = [...TICKER, ...TICKER];
  return (
    <div
      data-testid="ticker-bar"
      className="relative bg-[#E63946] border-y border-black overflow-hidden"
    >
      <div className="flex marquee-track py-4 whitespace-nowrap">
        {items.map((t, i) => (
          <div
            key={i}
            className="flex items-center gap-8 px-8 font-heading font-black text-white text-lg md:text-xl uppercase tracking-tight"
          >
            {t}
            <span className="text-black/70 text-xl">◆</span>
          </div>
        ))}
      </div>
    </div>
  );
}
